import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_COLOR = `${process.env.PUBLIC_URL}/urzu-logo-color.png`;
const LOGO_WHITE = `${process.env.PUBLIC_URL}/urzu-logo-white.png`;

const links = [
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Sectors", id: "sectors" },
  { label: "Partners", id: "partners" },
  { label: "Why Us", id: "why-us" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-slate-200" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <button data-testid="logo-home" onClick={() => go("hero")} className="flex items-center">
          <img
            src={scrolled ? LOGO_COLOR : LOGO_WHITE}
            alt="Urzu Media"
            className="h-12 sm:h-14 w-auto"
          />
        </button>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-700 hover:text-[#D91C29] transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:w-0 after:bg-[#D91C29] hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-contact-cta"
            onClick={() => go("contact")}
            className="rounded-full bg-[#D91C29] text-white text-sm font-semibold px-6 py-2.5 shadow-sm hover:bg-[#b3141f] hover:-translate-y-0.5 transition-transform transition-colors duration-200"
          >
            Contact Us
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2 text-[#0B1B3D]"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-b border-slate-200 px-5 pb-6 pt-2">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="text-left py-3 text-slate-700 font-medium border-b border-slate-100"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("contact")}
              className="mt-4 rounded-full bg-[#D91C29] text-white font-semibold px-6 py-3"
            >
              Contact Us
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
